// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-message[data-v-7aa95c46]{margin-top:.25rem;--tw-text-opacity:1;color:#ef4444}@supports (color:rgb(0 0 0/0)){.error-message[data-v-7aa95c46]{color:rgb(239 68 68/var(--tw-text-opacity))}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
